export const selectFoldingQueryParams = (state) => {
    if (!state.folding) {
        return undefined;
    }
    return {
        filterField: state.folding.fields.collection,
        childField: state.folding.fields.parent,
        parentField: state.folding.fields.child,
        filterFieldRange: state.folding.filterFieldRange,
    };
};
